import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IFiltredDashboardResponse } from '../interfaces/dashboard.interface';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getFiltredDashboard(flightDateSearch: string, beginDate: string, endDate: string): Observable<IFiltredDashboardResponse> {
        const apiUrl = `${this.baseUrl}/dashboard/filtered`;

        let params = new HttpParams()
            .set('flightDateSearch', flightDateSearch.toString())
            .set('beginDate', beginDate)
            .set('endDate', endDate);

        return this.http.get<IFiltredDashboardResponse>(apiUrl, { params });
    }
}
